import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import Image from 'next/image'
import React, { useMemo } from 'react'
import Slider from 'react-slick'
import LeftArrow from 'src/assets/leftArrow.png'
import RightArrow from 'src/assets/rightArrow.png'
import { HOMEPAGE_REMOVE_ITEMS } from 'src/config/config'
import { useExpertsQuery } from 'src/graphql/generated/hooks'

import { ExpertCard } from '../ExpertCard/ExpertCard'

export const ExpertsCarousel: React.FC = () => {
  const { data } = useExpertsQuery()
  const experts = useMemo(() => data?.experts || [], [data])

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: experts.length > 5 ? 5 : experts.length,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: (
      <div className="cursor-pointer">
        {HOMEPAGE_REMOVE_ITEMS ? (
          <Image src={RightArrow} className="w-[13px] h-[24px]" width={13} height={24} alt="" />
        ) : (
          <IonIcon name="chevron-forward-outline" className="!h-[30px] !w-[30px] text-[black] ml-auto"></IonIcon>
        )}
      </div>
    ),
    prevArrow: (
      <div className="cursor-pointer">
        {HOMEPAGE_REMOVE_ITEMS ? (
          <Image src={LeftArrow} className="w-[13px] h-[24px]" width={13} height={24} alt="" />
        ) : (
          <IonIcon name="chevron-back-outline" className="!h-[30px] !w-[30px] text-[black] ml-auto"></IonIcon>
        )}
      </div>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  }

  return (
    <div
      className={cn(
        'w-full px-5 sm:px-0 flex flex-row justify-center',
        HOMEPAGE_REMOVE_ITEMS ? 'bg-clouds expertsCarouselNew' : 'bg-white ',
      )}
    >
      <div className="max-w-screen-xl mx-32 w-full">
        <p className="w-full mt-[42px] font-secondary font-[700] md:text-[24px] text-[24px] leading-[36px] tracking-[0px] text-center text-[#222222]">
          Meet the Experts
        </p>
        <p className="w-full mt-[6px] font-primary  font-[400]  md:text-[18px] text-[18px] leading-[21.04px] tracking-[0px] text-center text-[#333333]">
          Our solution guides are written by our panel of experts. All leaders in their fields sharing their expertise
        </p>
        <div className="mx-10 mt-[49px] mb-[79px] ">
          <Slider {...settings} adaptiveHeight={false}>
            {experts.map((expert: any, idx: number) => (
              <ExpertCard key={idx} expert={expert} />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  )
}
